import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

import Delete from 'src/presentation/components/pages/shared/rowActions/DeleteV2';
import accountsResource, { Account, AccountType } from 'src/actions/accounts/accountsResource';

type RowActionProps = {
  item: Account;
};

const RowActions: FC<RowActionProps> = ({ item }) => {
  const dispatch = useDispatch();
  const params = getDeleteParams(item);
  const toastMessages = getToastMessages(item);
  const onDelete = ({ id }) => {
    dispatch(accountsResource.effects.removeAccount({ id, ...toastMessages }));
  };
  return (
    <Delete
      id={item.id}
      body={params.body}
      dataAidPrefix={params.dataAidPrefix}
      onDelete={onDelete}
      title={params.title}
    />
  );
};

type deleteParams = {
  body: React.ReactNode;
  dataAidPrefix: string;
  title: string;
};

type toastMessages = {
  errorMessage: string;
  successMessage: string;
};

function getToastMessages(account: Account): toastMessages {
  const name = `${account.content.name}`;
  return {
    errorMessage: `Failed to remove ${name} from Gladly. Please try again.`,
    successMessage: `${name} is no longer connected to Gladly.`,
  };
}

function getDeleteParams(account: Account): deleteParams {
  const name = `${account.content.name}`;
  if (account.type === AccountType.InstagramDirect) {
    return {
      body: (
        <>
          The Instagram account <b>{name}</b> will no longer be connected to Gladly. However, all previous
          communications from this account will remain visible in the Conversation Timeline.
        </>
      ),
      dataAidPrefix: 'instagram-account',
      title: 'Remove Instagram Account from Gladly',
    };
  }
  return {
    body: (
      <>
        The Facebook Page <b>{name}</b> will no longer be connected to Gladly. However, all previous communications from
        this account will remain visible in the Conversation Timeline.
      </>
    ),
    dataAidPrefix: 'facebook-page',
    title: 'Remove Facebook Page from Gladly',
  };
}

export default RowActions;
